import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import axios from "axios";
import CONFIG from "@/assets/js/config.custom.js";
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'TuitionFeePaymentReport',
    components: {
        MainLayout,
        Loading,
        AdvancedLaravelVuePaginate,
        Select2Multiple,
    },
    data() {
        return {
            isLoading: false,
            noDataMsg: CONFIG.NO_DATA_FOUND,
            academicYearArr: [],
            selectedAcdYear: null,
            paymentPlansData: [],
            paymentList: [],
            grandTotalAmounts: {},
            paginationData: {},
            currency: null,
            sortByField: 'student_no',
            sortOrder: 'asc',
            searchData: {
                student: null,
                payment_plan: 0,
            },
            paymentPlanArr: [{
                id: 0,
                text: "All"
            }, ...CONFIG.PAYMENT_PLANS],
        };
    },

    watch: {
        async selectedAcdYear(newVal) {
            if (newVal) {
                this.isLoading = true;
                this.paymentPlansData = {};
                this.paymentList = [];
                try {
                  await Promise.all([
                    this.getTotalTuitionPaymentForEachPlan(),
                    this.getTuitionPaymentList(),
                  ]);
                } catch (error) {
                  console.error("Failed to fetch tuition fee report data", error);
                } finally {
                  this.isLoading = false;
                }
            }
        }
    },

    methods: {
        sortBy(field) {
            if (this.sortByField === field) {
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortByField = field;
                this.sortOrder = 'asc';
            }
            this.getTuitionPaymentList(1);
        },
         getTotalTuitionPaymentForEachPlan() {
            axios.get("report/total-tuition-fee-payments", {
                params: {
                    acd_year_id: this.selectedAcdYear
                }
            })
            .then(res => {
                this.currency = res.data.currency;
                this.paymentPlansData = res.data.tuitionFeePlayments;
                this.grandTotalAmounts = Object.entries(this.paymentPlansData).reduce((data, [, plan]) => {
                    data.totalStudentCount += plan.student_ids?.length ?? 0;
                    data.totalActaulAmount += plan.actual_amount;
                    data.totalProratedAmount += plan.prorated_amount;
                    data.totalPaid += plan.paid_amount;
                    data.totalUnpaid += plan.unpaid_amount;
                    data.totalLateDays += plan.late_days;
                    data.totalLateFeeAmount += plan.late_fee_amount;
                    return data;
                }, {
                   totalStudentCount: 0, 
                   totalActaulAmount: 0, 
                   totalProratedAmount: 0, 
                   totalPaid: 0, 
                   totalUnpaid: 0, 
                   totalLateDays: 0, 
                   totalLateFeeAmount: 0, 
                });
            })
            .catch((error) => {
                if (error.response.status == 401) {
                this.$store.commit("logout");
                window.location.replace("login");
                }
            });
        },

        getTuitionPaymentList(page = 1) {
            this.isLoading = true;
            axios.get("report/tuition-fee-list?page=" + page,  {
                params: {
                    acd_year_id: this.selectedAcdYear,
                    student: this.searchData.student,
                    payment_plan: this.searchData.payment_plan ?? null,
                    sort_by: this.sortByField,
                    sort_order: this.sortOrder,
                }
            })
            .then(res => {
                this.paginationData = res.data.feeList || {};
                this.paymentList = res.data.feeList?.data ?? [];
                if (res.data.currency) {
                    this.currency = res.data.currency;
                }
            })
            .catch((error) => {
                this.paymentList = [];
                this.paginationData = {};
                if (error.response?.status == 401) {
                this.$store.commit("logout");
                window.location.replace("login");
                }
            })
            .finally(() => {
                this.isLoading = false;
            })
        },

        getAcademicYear() {
            axios.get("period/periodList")
            .then((res) => {
                this.academicYearArr = res.data.data;
            })
            .catch((error) => {
                if (error.response.status == 401) {
                this.$store.commit("logout");
                window.location.replace("login");
                }
            });
        },

        getCurrentYear() {
            axios.get("period/getThisAcademicYear")
            .then((res) => {
                this.selectedAcdYear = res.data.id;
            })
            .catch((error) => {
                if (error.response.status == 401) {
                this.$store.commit("logout");
                window.location.replace("login");
                }
            });
        },

        reset() {
            this.searchData = {
                student: null,
                payment_plan: 0,
            };
            this.sortByField = 'student_no';
            this.sortOrder = 'asc';
            this.getTuitionPaymentList(this.paginationData.current_page || 1);
        }
    },

    mounted() {
        this.isLoading = true;
        this.getAcademicYear();
        this.getCurrentYear();
    }
};
